export class PagingResponse<T> {
  pageNumber: number
  pageSize: number
  results: T[]
  totalResults: number

  constructor(pageNumber: number, pageSize: number, results: T[], totalResults: number) {
    this.pageNumber = pageNumber
    this.pageSize = pageSize
    this.results = results
    this.totalResults = totalResults
  }
}
